<section>
  <div class="grid grid-cols-1">
    <div #mapContainer class="map"
         [ngStyle]="{height: viewType === 'new' ? '500px' : '250px'}"
    >
    </div>
    <div class="flex items-center gap-2 px-2 py-1 rounded-md mt-5 bg-purple-100">
      <!-- Pin icon from lucide-angular -->
      <lucide-icon name="map-pinned" class="w-5 h-5 text-purple-600"></lucide-icon>

      <!-- Label -->
      <span class="font-semibold text-purple-600 select-none">{{ 'shared.interactiveMap.selectedLocation' | transloco }}:</span>

      <!-- Spacer -->
      <div class="flex-1"></div>

      <!-- Coordinates -->
      <span class="text-gray-600 text-sm select-none">
    {{ Math.abs(lngLat[1]).toFixed(3) }}°{{ lngLat[1] >= 0 ? 'N' : 'S' }},&nbsp;
        {{ Math.abs(lngLat[0]).toFixed(3) }}°{{ lngLat[0] >= 0 ? 'E' : 'W' }}
  </span>
    </div>
  </div>
</section>
